
import { escapeDataString } from "./fable_modules/fable-library-js.5.0.0/Util.js";
import { concat, join } from "./fable_modules/fable-library-js.5.0.0/String.js";
import { map } from "./fable_modules/fable-library-js.5.0.0/List.js";
import { Dictionary } from "./fable_modules/fable-library-js.5.0.0/MutableMap.js";
import { HashIdentity_Structural } from "./fable_modules/fable-library-js.5.0.0/FSharp.Collections.js";
import { FSharpRef, toString } from "./fable_modules/fable-library-js.5.0.0/Types.js";
import { tryGetValue } from "./fable_modules/fable-library-js.5.0.0/MapUtil.js";

export function downloadCsv(filename, rows) {
    const encoded = escapeDataString(join("\n", map((strings) => join(",", strings), rows)));
    const a = document.createElement("a");
    a.href = concat("data:text/csv;charset=utf-8,", ...encoded);
    a.download = filename;
    return a.click();
}

export function downloadFromUrl(url, filename) {
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    return a.click();
}

export function debounce() {
    let memoizations = new Dictionary([], HashIdentity_Structural());
    return (timeout) => ((fn) => ((value) => {
        const key = toString(fn);
        let matchValue;
        let outArg = 0;
        matchValue = [tryGetValue(memoizations, key, new FSharpRef(() => (outArg | 0), (v) => {
            outArg = (v | 0);
        })), outArg];
        if (matchValue[0]) {
            clearTimeout(matchValue[1]);
        }
        const timeoutId_1 = setTimeout(() => {
            memoizations.delete(key);
            fn(value);
        }, timeout) | 0;
        memoizations.set(key, timeoutId_1);
    }));
}

